import React from 'react'
import { Redirect } from 'react-router-dom'
import { AuthContext } from '../../contexts/Auth'

interface ListMenuItem {
  menu_path: string | null
  permission: Record<'c' | 'r' | 'u' | 'd', 0 | 1>
}

interface Props {
  path: string
  children: React.ReactNode
}

const RequireMenuPermission = ({ path, children }: Props): JSX.Element => {
  const context = React.useContext(AuthContext) as any
  const listMenu: ListMenuItem[] = context?.permission?.listMenu || []
  const menu = listMenu.find((item) => item.menu_path === path)
  const hasReadPermission = menu?.permission?.r === 1

  if (!hasReadPermission) {
    return <Redirect to="/" />
  }

  return <>{children}</>
}

export default RequireMenuPermission
